import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ConneqtOnAddPlayerDomain } from './conneqtOnAddPlayer.domain';
import { di } from '../../../state/inversify.config';
import { Pages } from '../../../state/queryParams/pageQueries.slice';
import { ConneqtSubRoutes } from '../../conneqt/conneqtSubRoutes';
import { AlertDialog } from '../../../components/alertDialog/alertDialog';

export function AddConneqtModal() {
  const { t } = useTranslation();
  const navigator = useNavigate();

  const sendConneqtDomain = di.get<ConneqtOnAddPlayerDomain>(
    ConneqtOnAddPlayerDomain,
  );
  const hasPendingConneqtInfo =
    sendConneqtDomain.useHasPendingConneqtInfoSelector();
  const [pendingConneqtRequestModal, setShowPendingConneqtRequestModal] =
    useState(false);

  const handleConneqtCreate = () => {
    sendConneqtDomain.dispatchCreateConneqtForPlayer();
    navigator(`../${Pages.conneqt}/${ConneqtSubRoutes.sent}`);
  };

  const onDismiss = () => {
    setShowPendingConneqtRequestModal(false);
    sendConneqtDomain.useDispatchClearViewServices();
  };

  useEffect(() => {
    setShowPendingConneqtRequestModal(hasPendingConneqtInfo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasPendingConneqtInfo]);

  return (
    <>
      {pendingConneqtRequestModal && (
        <AlertDialog
          onDismiss={onDismiss}
          actions
          title={t('CONNEQT_THIS_PLAYER_TO_GUARDIAN')}
          setOpen={setShowPendingConneqtRequestModal}
          open={hasPendingConneqtInfo}
          content={t('WOULD_YOU_LIKE_TO_CONNEQT_REQUEST')}
          onConfirm={handleConneqtCreate}
          confirmLabel={t('CONFIRM')}
          cancelLabel={t('CANCEL')}
        />
      )}
    </>
  );
}
